module.exports = __webpack_public_path__ + "img/lens-167-plus-04.1321ab89.png";